// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/address_types.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "photon.imessage.v1";

export enum ChatServiceType {
  CHAT_SERVICE_TYPE_UNSPECIFIED = 0,
  CHAT_SERVICE_TYPE_IMESSAGE = 1,
  CHAT_SERVICE_TYPE_SMS = 2,
  CHAT_SERVICE_TYPE_RCS = 3,
  UNRECOGNIZED = -1,
}

export function chatServiceTypeFromJSON(object: any): ChatServiceType {
  switch (object) {
    case 0:
    case "CHAT_SERVICE_TYPE_UNSPECIFIED":
      return ChatServiceType.CHAT_SERVICE_TYPE_UNSPECIFIED;
    case 1:
    case "CHAT_SERVICE_TYPE_IMESSAGE":
      return ChatServiceType.CHAT_SERVICE_TYPE_IMESSAGE;
    case 2:
    case "CHAT_SERVICE_TYPE_SMS":
      return ChatServiceType.CHAT_SERVICE_TYPE_SMS;
    case 3:
    case "CHAT_SERVICE_TYPE_RCS":
      return ChatServiceType.CHAT_SERVICE_TYPE_RCS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChatServiceType.UNRECOGNIZED;
  }
}

export function chatServiceTypeToJSON(object: ChatServiceType): string {
  switch (object) {
    case ChatServiceType.CHAT_SERVICE_TYPE_UNSPECIFIED:
      return "CHAT_SERVICE_TYPE_UNSPECIFIED";
    case ChatServiceType.CHAT_SERVICE_TYPE_IMESSAGE:
      return "CHAT_SERVICE_TYPE_IMESSAGE";
    case ChatServiceType.CHAT_SERVICE_TYPE_SMS:
      return "CHAT_SERVICE_TYPE_SMS";
    case ChatServiceType.CHAT_SERVICE_TYPE_RCS:
      return "CHAT_SERVICE_TYPE_RCS";
    case ChatServiceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * An address bound to one concrete transport service. Used when the server
 * must identify a specific (handle, service) pair: message sender, chat
 * participant, etc.
 */
export interface SingleServiceAddressInfo {
  address: string;
  service: ChatServiceType;
  country?: string | undefined;
}

/**
 * An address paired with every service observed for it.
 *
 * `services` is emitted in canonical (iMessage, SMS, RCS) order. Clients
 * should treat it as a set, not a sequence. GetAddressInfo returns NOT_FOUND
 * instead of this message when the address has no observed handle rows.
 */
export interface MultiServiceAddressInfo {
  /**
   * Canonical form: emails lowercased, phones E.164. May differ from the
   * request value's casing or whitespace.
   */
  address: string;
  services: ChatServiceType[];
  /**
   * ISO 3166-1 alpha-2, when known. The chat.db address lookup normalizes it
   * to uppercase; mappers preserve the value they receive.
   */
  country?: string | undefined;
}

function createBaseSingleServiceAddressInfo(): SingleServiceAddressInfo {
  return { address: "", service: 0, country: undefined };
}

export const SingleServiceAddressInfo: MessageFns<SingleServiceAddressInfo> = {
  encode(message: SingleServiceAddressInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }
    if (message.service !== 0) {
      writer.uint32(16).int32(message.service);
    }
    if (message.country !== undefined) {
      writer.uint32(26).string(message.country);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SingleServiceAddressInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSingleServiceAddressInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.address = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.service = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.country = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SingleServiceAddressInfo {
    return {
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      service: isSet(object.service) ? chatServiceTypeFromJSON(object.service) : 0,
      country: isSet(object.country) ? globalThis.String(object.country) : undefined,
    };
  },

  toJSON(message: SingleServiceAddressInfo): unknown {
    const obj: any = {};
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.service !== 0) {
      obj.service = chatServiceTypeToJSON(message.service);
    }
    if (message.country !== undefined) {
      obj.country = message.country;
    }
    return obj;
  },

  create(base?: DeepPartial<SingleServiceAddressInfo>): SingleServiceAddressInfo {
    return SingleServiceAddressInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SingleServiceAddressInfo>): SingleServiceAddressInfo {
    const message = createBaseSingleServiceAddressInfo();
    message.address = object.address ?? "";
    message.service = object.service ?? 0;
    message.country = object.country ?? undefined;
    return message;
  },
};

function createBaseMultiServiceAddressInfo(): MultiServiceAddressInfo {
  return { address: "", services: [], country: undefined };
}

export const MultiServiceAddressInfo: MessageFns<MultiServiceAddressInfo> = {
  encode(message: MultiServiceAddressInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }
    writer.uint32(18).fork();
    for (const v of message.services) {
      writer.int32(v);
    }
    writer.join();
    if (message.country !== undefined) {
      writer.uint32(26).string(message.country);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultiServiceAddressInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultiServiceAddressInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.address = reader.string();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.services.push(reader.int32() as any);

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.services.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.country = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MultiServiceAddressInfo {
    return {
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      services: globalThis.Array.isArray(object?.services)
        ? object.services.map((e: any) => chatServiceTypeFromJSON(e))
        : [],
      country: isSet(object.country) ? globalThis.String(object.country) : undefined,
    };
  },

  toJSON(message: MultiServiceAddressInfo): unknown {
    const obj: any = {};
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.services?.length) {
      obj.services = message.services.map((e) => chatServiceTypeToJSON(e));
    }
    if (message.country !== undefined) {
      obj.country = message.country;
    }
    return obj;
  },

  create(base?: DeepPartial<MultiServiceAddressInfo>): MultiServiceAddressInfo {
    return MultiServiceAddressInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MultiServiceAddressInfo>): MultiServiceAddressInfo {
    const message = createBaseMultiServiceAddressInfo();
    message.address = object.address ?? "";
    message.services = object.services?.map((e) => e) || [];
    message.country = object.country ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
